// Accepts any valid domain + TLD (.com, .co, .ng, .co.uk, etc.)
const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

// Common gmail domain typos we want to catch and nudge the user to fix.
const GMAIL_MISSPELLINGS = [
  "gmal.com",
  "gmial.com",
  "gmai.com",
  "gmail.co",
  "gimail.com",
  "gmail.con",
];

/**
 * Validate an email address.
 * @param {string} email
 * @returns {string} An error message, or "" if the email is valid.
 */
export const validateEmail = (email) => {
  if (!email) {
    return "Please enter your Email";
  }

  if (!EMAIL_REGEX.test(email)) {
    return "Invalid email! Please enter a valid email address.";
  }

  const domain = email.split("@")[1].toLowerCase();
  if (GMAIL_MISSPELLINGS.includes(domain)) {
    return 'Did you mean "gmail.com"? Please check your email domain.';
  }

  return "";
};

/**
 * Convenience boolean check.
 * @param {string} email
 * @returns {boolean}
 */
export const isValidEmail = (email) => validateEmail(email) === "";
